<div class="p-5" [class.disabled]="loading">
    <p class="text-lg mb-3">
        Recall Discrepancy {{ data.discrepancyNo }} to “Initial Review”
    </p>
    This action will:
    <ul class="pl-6">
        <li>Make the discrepancy editable</li>
        @if (revisionsToBeSevered.length > 0) {
            <li>
                <p class="text-bold">
                    Remove the following corrections from this discrepancy:
                </p>
                <ul class="pl-6" style="list-style-type: disc">
                    @for (revision of revisionsToBeSevered; track revision.id) {
                        <li>{{ revision.revisionName }}</li>
                    }
                </ul>
            </li>
        }
        @if (revisionsToBeDeleted.length > 0) {
            <li>
                <p class="text-bold">
                    Permanently delete the following corrections:
                </p>
                <ul class="pl-6" style="list-style-type: disc">
                    @for (revision of revisionsToBeDeleted; track revision.id) {
                        <li>{{ revision.revisionName }}</li>
                    }
                </ul>
            </li>
        }
    </ul>
    <div class="flex justify-end gap-8 mt-5">
        <app-flat-button
            mat-dialog-close
            [dataQa]="dataQa.recallForEditDialogCancel">
            Cancel
        </app-flat-button>
        <app-flat-button
            variant="tertiary"
            [dataQa]="dataQa.recallForEditDialogRecall"
            (clicked)="recall()">
            Recall and Edit Discrepancy
        </app-flat-button>
    </div>
    @if (error) {
        <div class="flex justify-end gap-8">
            <small class="color-status-red4"> Something went wrong </small>
        </div>
    }
</div>

@if (loading) {
    <app-loader type="overlay" position="absolute" />
}
